import { useCallback, useState } from 'react';

import { closedStorageKey } from './WorkflowVersionHistoryPromotion.constants';

export const useSaveToLocalStorage = () => {
    const [isClosedPromotion, setIsClosedPromotion] = useState(() => localStorage.getItem(closedStorageKey) === 'true');

    const closePromotion = useCallback(() => {
        localStorage.setItem(closedStorageKey, 'true');
        setIsClosedPromotion(true);
    }, []);

    return {
        closePromotion,
        isClosedPromotion,
    };
};
